// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"b000a0e8","122":"ce8eb643","251":"460e0125","433":"100b8fd2","512":"4b622da9","517":"d88444c5","521":"665fe47b","640":"10886090","655":"1ef5eafa","705":"48ee0fff"}[chunkId] + ".chunk.css";
};